module.exports = __webpack_public_path__ + "static/07-1fe24b0679033c579979d8d48c96ff97.jpg";